import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  Routes,
  Route,
  BrowserRouter
} from "react-router-dom"
import Merch from './components/Merch';
import AdminPage from "./AdminPage";
import { useSearchParams } from 'react-router-dom';
import { ParamsProvider } from './components/ParamsContext';
import { ConferenceConfigProvider } from './components/ConferenceConfigContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
//<Route path="/merch" element={<Merch />} />

function Home() {
  const [queryParameters] = useSearchParams();

  const discount = queryParameters.get("discount") ?? null;

  // Convert query parameters to boolean values correctly
  const noLateFee = queryParameters.get("nolatefee") === 'true';
  const allowLateRegistration = queryParameters.get("allowlateregistration") === 'true';
  const partTime = queryParameters.get("parttime") ?? null;

  const params = {
    discount,
    noLateFee,
    allowLateRegistration,
    partTime
  };

  return (
    <ParamsProvider value={params}>
      <ConferenceConfigProvider>
        <App />
      </ConferenceConfigProvider>
    </ParamsProvider>
  );
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
